<template>
    <label
        :for="name"
        class="z-input vm-form-el"
        :class="{
            'is-error': error,
            'is-filled': val,
            'is-focused': focus,
            'is-disabled': disabled,
            'z-input--search': theme === 'search',
            'z-input--tel': type === 'tel'
        }"
    >
        <z-icon
            width="24"
            height="24"
            name="search"
            color="#000"
            v-if="theme === 'search' && position === 'left'"
            @click="change(val)"
        />
        <input
            :id="name"
            :name="name"
            :type="type"
            :min="min"
            :max="max"
            v-model="val"
            autocomplete="off"
            :disabled="disabled"
            @blur="onBlur"
            @focus="focus = true"
            @input="input($event.target.value)"
            @change="change($event.target.value)"
            @keyup.enter="enter($event.target.value)"
            :maxlength="type === 'tel' ? '17' : '255'"
            v-phone="type === 'tel'"
            :pattern="pattern"
        />
        <span
            v-html="placeholder"
            class="z-input__placeholder"
            v-if="placeholder"
        ></span>
        <span
            class="z-input__error vm-form-el__error"
            v-if="required && error"
        >
            <span v-if="!val">{{ text.errors.required }}</span>
        </span>
        <span
            class="z-input__error vm-form-el__error"
            v-if="val && type === 'email' && error"
        >
            {{ text.errors.invalid.email }}
        </span>
        <span
            class="z-input__error vm-form-el__error"
            v-if="val && type === 'tel' && error"
        >
            {{ text.errors.invalid.phone }}
        </span>
        <span
            class="z-input__error"
            v-if="error && pattern"
        >
            <span>{{ titlePattern }}</span>
        </span>
        <z-icon
            width="24"
            height="24"
            color="#000000"
            @click="resetVal"
            :name="val.length > 0 ? 'close' : 'search'"
            v-if="theme === 'search' && position === 'right'"
        />
    </label>
</template>

<script>
import { phoneMask } from '@/utils/phoneMask'

export default {
    name: 'z-input',
    props: {
        value: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default: 'text',
            validator: prop => ['text', 'tel', 'email', 'password', 'number'].includes(prop)
        },
        pattern: [String, RegExp],
        titlePattern: String,
        theme: {
            type: String,
            default: 'text',
            validator: prop => ['text', 'search'].includes(prop)
        },
        position: {
            type: String,
            default: 'left',
            validator: prop => ['left', 'right'].includes(prop)
        },
        disabled: Boolean,
        required: Boolean,
        placeholder: String,
        min: [String, Number],
        max: [String, Number]
    },
    data () {
        return {
            error: false,
            focus: false,
            val: this.value,
            text: {
                errors: {
                    required: this.$root.lang === 'ru' ? 'Поле обязательно для заполнения' : 'Required field',
                    invalid: {
                        email: this.$root.lang === 'ru' ? 'Формат для e-mail указан неверно' : 'Invalid email format',
                        phone: this.$root.lang === 'ru' ? 'Неверный формат' : 'Invalid format'
                    }
                }
            }
        }
    },
    directives: {
        phone: phoneMask
    },
    watch: {
        value (val) {
            this.val = val
        },
        required (val) {
            this.validate()
        }
    },
    methods: {
        clearIncompletedPhone () {
            if (this.val === '+7 ') {
                this.resetVal()
                this.$emit('input', this.val)
            }
        },
        onBlur () {
            this.focus = false
            if (this.type === 'tel') this.clearIncompletedPhone()
        },
        clear () {
            this.resetVal()
        },
        isValuePropSet () {
            return (
                !!this.$options.propsData && this.$options.propsData.value !== undefined
            )
        },
        resetVal () {
            if (this.val.length > 0) {
                this.val = ''
                this.change('')
            }
        },
        enter (value) {
            this.change(value)
            this.$emit('enter', value)
        },
        change (value) {
            this.validate(value)
            this.$emit('change', value)
        },
        input (value) {
            this.validate(value)
            this.$emit('input', value)
        },
        validateEmail (email) {
            // eslint-disable-next-line no-useless-escape
            let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return regex.test(email)
        },
        checkEmail (value) {
            if (!this.validateEmail(value)) this.error = true
        },
        checkTel (value) {
            let regex = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/
            return regex.test(value)
        },
        checkPattern (value) {
            let val = value
            if (this.type === 'number' && value) {
                val = +val
            }
            const regex = new RegExp(this.pattern)
            const isValid = regex.test(val)

            if (!isValid) this.error = true
        },
        validate () {
            if (this.required && !this.val) {
                this.error = true
            } else {
                this.error = false
                if (this.pattern) this.checkPattern(this.val)

                if (this.val && this.type === 'email') {
                    this.checkEmail(this.val)
                } else if (this.type === 'tel') {
                    if (this.val !== '' && this.val.length < 17) this.error = true
                    // this.checkTel(this.val)
                }
            }
        }
    }
}

</script>

<style lang="scss" src="./index.scss"></style>
